// Two-wave Klemento logomark in currentColor. Used in the sidebar lockup
// and signed-out shell header. Canonical version per
// .claude/skills/klemento-design/ui_kits/app/index.html.

export function Logomark({ size = 22 }: { size?: number }) {
  return (
    <svg viewBox="0 0 64 64" width={size} height={size} aria-label="Klemento" role="img">
      <path
        d="M 8 24 C 14 14, 20 14, 24 24 C 28 34, 30 34, 32 24 C 34 14, 38 14, 42 24 C 46 34, 52 34, 56 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M 56 40 C 50 50, 44 50, 40 40 C 36 30, 34 30, 32 40 C 30 50, 26 50, 22 40 C 18 30, 12 30, 8 40"
        fill="none"
        stroke="currentColor"
        strokeWidth="4.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
